import {AlertCircleIcon, CheckCircleIcon} from '@components/ui/icon'
import {Spinner} from '@components/ui/spinner'

interface InputStatusIconProps {
    hasError?: boolean
    touched?: boolean
    isLoading?: boolean
}
export const InputStatusIcon = ({hasError, touched, isLoading}: InputStatusIconProps) => {
    return (
        <>
            {isLoading && <Spinner size={16} fill="var(--color-neutral-600)" />}
            {hasError && !isLoading && <AlertCircleIcon className="text-danger-300" size={16} />}
            {touched && !hasError && !isLoading && <CheckCircleIcon className="text-success-300" size={16} />}
        </>
    )
}

InputStatusIcon.displayName = 'InputStatusIcon'
